// @core/api/endpoints/workflow/delete_test_case.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/workflow';

/**
 * Delete test case
 * Deletes a test case and its results.
 */
export async function DeleteTestCase(
  test_case_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/test-cases/:test_case_id`;
  requestPath = requestPath.replace(':test_case_id', encodeURIComponent(test_case_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
